import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthXService } from "@authx/authx-workflow-lib";
import { CookieService } from "ngx-cookie";
import { catchError, switchMap, take, takeUntil, throwError } from "rxjs";
import { UserContext } from "src/app/_context/user.context";
import { UserService, AuthenticationService } from "src/app/_services";
import { FederatedAuthenticationService } from "src/app/_services/federated-authentication.service";
import { Oauth2LoginComponent } from "src/app/oauth2-login/oauth2-login.component";
import { Constants } from "src/app/shared/Helpers/constants";
import { ILoginRequest } from "src/app/shared/interfaces/general.interface";
import { SharedService } from "src/app/shared/shared.service";
import { Buffer } from 'buffer';

@Component({
  selector: 'broker-login',
  templateUrl: "./broker-login.component.html",
})
export class BrokerLoginComponent extends Oauth2LoginComponent {
  public logoPath: string = Constants.newEraTechLogo;
  public ableLogoPath: string = Constants.logoPath;
  public emailNotFound: boolean = false

  constructor(
    protected sharedService: SharedService,
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected userService: UserService,
    protected userContext: UserContext,
    protected authenticationService: AuthenticationService,
    protected cookieService: CookieService,
    protected authXService: AuthXService,
    protected federatedAuthService: FederatedAuthenticationService
  ) {
    super(
      sharedService,
      activatedRoute,
      router,
      userService,
      userContext,
      authenticationService,
      cookieService,
      authXService,
      federatedAuthService
    )
    const backgroundImageFromRoute = this.activatedRoute.snapshot.data['backgroudImage'];
    this.sharedService.BackgroundImage.next(backgroundImageFromRoute);
  }


  public handleLoginEvents =  (isValid: boolean) => {
    console.log("Broker login component handleLoginEvents called", this.loginModel, this.organisationId);
    this.loading = true;
    const body: ILoginRequest = {
      username: this.loginModel.username,
      password: this.loginModel.password,
      organisationId: this.organisationId
    }
        this.userService.checkUsernameAuthenticationWithOrganisation(this.loginModel.username, this.organisationId)
          .pipe(
            take(1),
            catchError((error) => {
              this.loading = false;
              // this.onUsernameValidationError(error, this.loginModel?.organisation);
              this.emailNotFound = true;
              return throwError(() => null);
            }),
            switchMap(res =>
                this.authenticationService.emailPasswordLogin(body).pipe(takeUntil(this._destroySubscription$))
            )
        ).subscribe({
      next: (response) => {
        this.loading = false;
        this.handleUserLoginResponse(response)
      },
      error: (error) => {
        this.loading = false;
        this.handleUserLoginError(error)
    }
  });
  }

  public onLoginReset = () => {
    this.loginModel.username = '';
    this.loginModel.password = '';
    this.emailNotFound = false;
  }

  public handleUserLoginResponse = (response: any) => {
      const decodedUrl = Buffer.from(this.encodedAuthorizationUrl, 'base64').toString('utf8');
      localStorage.removeItem('authorizationUrl');
      window.location.href = `${decodedUrl}?token=${response.token}`;
  }

  //Overide the afterProvidersCheck method and do nothing
  public afterProvidersCheck: () => void;
}
